//ヘッダーサーチボタン
$(".open-btn1").click(function () {
    $(this).toggleClass('btnactive');
    $("#search-wrap").toggleClass('panelactive');
  $('#search-text').focus();
});	

//ヘッダーアコーディオンメニュー
$(function(){
  $('.s_07 .accordion_one .accordion_header').on('click', function(){
    $(this).toggleClass('open');
    $(this).next('.accordion_inner').toggleClass('open');
  });
});

//ヘッダーメニューモーダルアクション
(function($) {
  var $nav    = $('#navArea');
  var $header = $('.header_area');
  var $btn    = $('.toggle_btn');
  var $mask   = $('#mask');
  var open    = 'open';
  var fixed   = 'is-fixed'; // body用

  // menu open/close
  $btn.on('click', function() {
    if ( !$nav.hasClass(open) ) {
      $nav.addClass(open);
      $header.addClass(open);
      $('body').addClass(fixed);   // ←追加
    } else {
      $nav.removeClass(open);
      $header.removeClass(open);
      $('body').removeClass(fixed); // ←追加
    }
  });

  // mask close
  $mask.on('click', function() {
    $nav.removeClass(open);
    $header.removeClass(open);
    $('body').removeClass(fixed);   // ←追加
  });

})(jQuery);


//ヘッダー背景色変更
$(function() {
  var header_fixed = $('.header_fixed_sp');
  $(window).on('load scroll', function(){
    if($(this).scrollTop() > 100) {
      header_fixed.addClass('header_bg_active');
    }else{
      header_fixed.removeClass('header_bg_active');
    }
  });
});

